/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CarePrincipalExportOverChargedSettingsEntity
 */
export interface CarePrincipalExportOverChargedSettingsEntity {
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalExportOverChargedSettingsEntity
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalExportOverChargedSettingsEntity
     */
    carePrincipalId?: string;
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalExportOverChargedSettingsEntity
     */
    cardType?: string;
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalExportOverChargedSettingsEntity
     */
    cronPattern?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CarePrincipalExportOverChargedSettingsEntity
     */
    excludeMissingPatients?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalExportOverChargedSettingsEntity
     */
    ftpName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CarePrincipalExportOverChargedSettingsEntity
     */
    emptyExportFiles?: boolean;
}

export function CarePrincipalExportOverChargedSettingsEntityFromJSON(json: any): CarePrincipalExportOverChargedSettingsEntity {
    return CarePrincipalExportOverChargedSettingsEntityFromJSONTyped(json, false);
}

export function CarePrincipalExportOverChargedSettingsEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarePrincipalExportOverChargedSettingsEntity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'carePrincipalId': !exists(json, 'carePrincipalId') ? undefined : json['carePrincipalId'],
        'cardType': !exists(json, 'cardType') ? undefined : json['cardType'],
        'cronPattern': !exists(json, 'cronPattern') ? undefined : json['cronPattern'],
        'excludeMissingPatients': !exists(json, 'excludeMissingPatients') ? undefined : json['excludeMissingPatients'],
        'ftpName': !exists(json, 'ftpName') ? undefined : json['ftpName'],
        'emptyExportFiles': !exists(json, 'emptyExportFiles') ? undefined : json['emptyExportFiles'],
    };
}

export function CarePrincipalExportOverChargedSettingsEntityToJSON(value?: CarePrincipalExportOverChargedSettingsEntity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'carePrincipalId': value.carePrincipalId,
        'cardType': value.cardType,
        'cronPattern': value.cronPattern,
        'excludeMissingPatients': value.excludeMissingPatients,
        'ftpName': value.ftpName,
        'emptyExportFiles': value.emptyExportFiles,
    };
}

